<template>
  <div class="repay-result">
    <!-- 只是为了兼容在APP内的情况 -->
    <navigation adaption />

    <pulldown-page class="pull-down" :refresh="pulldown" background="white" color="#333333">

      <!-- 线上还款 -->
      <div class="repay-status">
        <div class="animation-wapper">
          <lottie ref="animataionLoading" v-if="detail.batchStatus === 'IN_PROGRESS'" :options="showGif[0]" />
          <lottie ref="animataionLoading" v-if="detail.batchStatus === 'FAIL'" :options="showGif[1]" />
          <lottie ref="animataionLoading" v-if="['PART', 'SUCCESS'].includes(detail.batchStatus)" :options="showGif[2]" />
        </div>
        <p class="status-title">{{ title }}</p>
        <div class="status-description" v-html="desc"></div>
      </div>

      <div class="bill-info" v-if="['PART', 'SUCCESS'].includes(detail.batchStatus)">
        <div class="item">
          <p class="title">申请还款金额</p>
          <p class="content number">￥{{ detail.totalAmt | currency }}</p>
        </div>
        <div class="item">
          <p class="title">还款成功金额</p>
          <p class="content number">￥{{ detail.realTotalAmt | currency }}</p>
        </div>
        <div class="item">
          <p class="title">还款时间</p>
          <p class="content number">{{ detail.repayTime }}</p>
        </div>
      </div>

      <div class="btn-container">
        <div class="call" @click="serviceVisible = true" v-if="['FAIL', 'PART'].includes(detail.batchStatus)">
          <img src="../../../assets/images/call.png" />
          <span class="contact">联系客服</span>
        </div>

        <nd-button class="repay-btn" v-if="['PART'].includes(detail.batchStatus)" @click="handleRepay">再次还款</nd-button>
        <nd-button class="repay-btn" v-if="['FAIL'].includes(detail.batchStatus)" @click="handleRepay">重新还款</nd-button>
        <nd-button :class="['btn small line repay-btn']" @click="backHome">返回首页</nd-button>
      </div>
    </pulldown-page>

    <!-- 联系客服弹窗框 -->
    <ServiceJw v-model="serviceVisible"></ServiceJw>
  </div>
</template>

<script>
import { fail, wait, success } from '@/assets/json/index'
import { mapActions } from 'vuex'
import Lottie from 'vue-lottie'
import ServiceJw from '@/components/service-jw'
export default {
  name: 'repayment-result',
  customReadyNotify: true,
  components: {
    lottie: Lottie,
    ServiceJw
  },

  data () {
    return {
      title: '还款中',
      desc: '订单状态稍后更新，请留意查看 <br> 还款结果会在1-3个工作日内到账',
      serviceVisible: false,
      timer: null,
      batchNo: this.$route.query.batchNo,
      detail: {},
      showGif: [
        { animationData: wait },
        { animationData: fail, loop: false },
        { animationData: success, loop: false }
      ]
    }
  },

  mounted () {
    this.getResult()
    sessionStorage.removeItem('repayOrderSelect')
    sessionStorage.removeItem('repayExpenseSelect')
    this.$bus.$emit('ready')
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  methods: {
    ...mapActions('order', [
      'getRepayBatchResultX'
    ]),
    handleRepay () {
      this.$router.push('/repayment/history')
    },
    async getResult () {
      const { success, data } = await this.getRepayBatchResultX({
        batchNo: this.batchNo
      })
      const { batchStatus } = data
      const titleMap = {
        IN_PROGRESS: '还款中',
        SUCCESS: '还款成功',
        FAIL: '还款失败',
        PART: '部分还款成功'
      }
      const descMap = {
        IN_PROGRESS: '您的还款申请已提交，请耐心等待还款结果',
        SUCCESS: '恭喜还款成功，订单状态稍后更新，请留意查看',
        FAIL: '抱歉，本次还款失败，请您稍后重新发起还款；<br/>如有疑问，联系客服。',
        PART: '订单状态稍后更新，请留意查看'
      }
      this.title = titleMap[batchStatus] || '还款中'
      this.desc = descMap[batchStatus] || '订单状态稍后更新，请留意查看 <br> 还款结果会在1-3个工作日内到账'

      this.$sensors.track('quick_repay_reslut', { msg_name: this.title })
      if (success) {
        this.detail = data || {}
      }
    },
    // 下拉刷新
    pulldown () {
      window.location.reload()
    }
  },
  computed: {}
}
</script>

<style lang="less">
@import "../../../assets/less/mixin.less";

.btn-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  margin-top: 50px;

  .repay-btn {
    width: 320px !important;
    height: 80px !important;
    line-height: 80px !important;
  }
}

.page {
  overflow: auto;
  min-height: 100vh;

  .repay-status {
    margin-top: 128px;
    display: flex;
    flex-direction: column;
    gap: 30px;
    align-items: center;

    .status-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 42px;
      color: #333333;
    }

    .status-description {
      font-size: 26px;
      color: #666666;
      text-align: center;
    }

    .animation-wapper {
      height: 210px;
      width: 210px;
      margin: 0 auto;
    }
  }

  .bill-info {
    padding: 0 30px;
    margin-top: 42px;
    padding-top: 42px;
    margin-left: 42px;
    margin-right: 42px;
    padding-bottom: 20px;
    font-size: 28px;
    text-align: left;
    background-color: #fafafa;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    border-radius: 20px;
    line-height: 50px;

    .item {
      display: flex;
      flex-direction: row;

      .title {
        color: @fc2;
        flex-shrink: 0;
      }

      .content {
        color: @fc1;
        margin-left: 42px;
      }

      .number {
        font-family: DIN-Medium, DIN;
        word-break: break-all;
      }
    }
  }

  .call {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 200px;
    height: 60px;
    background: #fafafa;
    border-radius: 40px;
    border: 1px solid #eeeeee;
    padding: 0 23px 0 28px;

    img {
      width: 29px;
      height: 29px;

      span {
        width: 104px;
        height: 37px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 37px;
      }
    }
  }
}
</style>
